import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ServiceCard({ service }) {
  return (
    <Link
      to={`/services#${service.anchor}`}
      className="group flex flex-col overflow-hidden rounded-lg bg-white shadow-sm ring-1 ring-black/5 transition-shadow hover:shadow-lg"
    >
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={service.image}
          alt={service.imageAlt}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-6">
        <h3 className="font-display text-xl font-semibold text-charcoal">
          {service.shortName}
        </h3>
        <p className="mt-2 flex-1 text-sm text-steel">{service.summary}</p>
        <span className="mt-4 inline-flex items-center gap-1 font-display text-sm uppercase tracking-wide text-brick group-hover:text-brick-light">
          Learn more <ArrowRight size={16} />
        </span>
      </div>
    </Link>
  );
}
